<script>
import LiveReportService from '@/services/ReportModules/LiveReportService'
import salesCheckListModal from '@/components/modals/sales/salesCheckListModal'

export default {
  props: {
    tableTitle: {
      type: String,
      default () {
        return ''
      }
    }
  },
  created () {
    this.location_id = this.$route.params.location_id
  },
  data () {
    return {
      items: [],
      loading: false,
      expanded: true
    }
  },
  methods: {
  },
  mounted () {
    this.loading = true
    this.$updateloading(1)
    LiveReportService.getItemTracking(this.location_id).then(data => {
      this.items = data.items
      this.loading = false
      this.$updateloading(-1)
    })
  },
  components: {
    salesCheckListModal
  }
}

</script>

<template>
  <div class="row">
    <div class="col-sm-12">
      <div class="well">
        <div class="list-group">
          <div class="list-group-item active">
            <div class="list-group-item-heading float-left "><strong>{{tableTitle}}</strong></div>
            <div class="list-group-item-heading float-right ">
              <a
                href="javascript:void(0)"
                v-on:click="expanded = !expanded"
              >
                <i class="fas fa-minus-square"
                v-show="expanded"></i>
                 <i class="fas fa-plus-square"
                v-show="!expanded"></i>
              </a>
            </div>
          </div>
          <div
            v-show="expanded"
            v-if="loading == false && items.length == 0"
            class="list-group-item text-center"
          >
            No tracked items.
          </div>
          <div
            v-show="expanded"
            v-if="items.length > 0"
            class="list-group-item"
          >
            <div class="row">
              <div class="col table-responsive">
                <table class="table table-condensed ">
                  <thead>
                    <tr>
                      <th>Item</th>
                      <th class="d-xs-none">Category</th>
                      <th class="text-center">Sold</th>
                      <th class="text-right">Sales</th>
                      <th class="text-right">Avg Price</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr
                      v-for="(row, index) in this.items"
                      :key="index"
                    >
                      <td>{{row.item}}</td>
                      <td class="d-xs-none">{{row.category}}</td>
                      <td class="text-center">
                        <span v-show="row.numSold > 0">
                          <sales-check-list-modal
                            :locationId="location_id"
                            :itemId="row.itemid"
                            :inday="true"
                          >{{ row.numSold }}
                          </sales-check-list-modal>
                        </span>
                      </td>
                      <td class="text-right">{{row.sales | formatNumber('$0,0.00') }}</td>
                      <td class="text-right">{{row.avgPrice | formatNumber('$0,0.00') }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped></style>
